module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloudy-night-370a9fa10ae8d866d569daa7107619b4.svg";